// /store/modules/statistics.js
import apiClient from '../../plugins/axios';

export default {

  namespaced: true,

  state: () => ({
    sourceOfLeads: null,
    sourceOfLeadsPast30Days: null,
    sourceOfLeadsPast7Days: null,
    emailConnections: null,
    tableStats: null,
    customerStats: null,
    agencyStats: null,
    statisticsAge: null,
    customerLoginStats: null,
    whatsAppConnectionsStats: null,
    whatsAppConnectionsPerAgencyStats: null,
    whatsAppMessagesStats: null,
    whatsAppMessagesPerAgencyCustomer: null,
    statisticsFromStatistics: null,
    whatsAppUsage: null,
    loading: false,
    progress: {
      currentStep: 0,
      totalSteps: 0,
      currentStatisticName: null,
    },
  }),

  mutations: {
    setSourceOfLeads(state, sourceOfLeads) {
      state.sourceOfLeads = sourceOfLeads;
    },
    setSourceOfLeadsPast30Days(state, sourceOfLeadsPast30Days) {
      state.sourceOfLeadsPast30Days = sourceOfLeadsPast30Days;
    },
    setSourceOfLeadsPast7Days(state, sourceOfLeadsPast7Days) {
      state.sourceOfLeadsPast7Days = sourceOfLeadsPast7Days;
    },
    setemailConnections(state, emailConnections) {
      state.emailConnections = emailConnections;
    },
    setTableStats(state, tableStats) {
      state.tableStats = tableStats;
    },
    setCustomerStats(state, customerStats) {
      state.customerStats = customerStats;
    },
    setAgencyStats(state, agencyStats) {
      state.agencyStats = agencyStats;
    },
    setStatisticsAge(state, statisticsAge) {
      state.statisticsAge = statisticsAge;
    },
    setCustomerLoginStats(state, customerLoginStats) {
      state.customerLoginStats = customerLoginStats;
    },
    setWhatsAppConnectionsStats(state, whatsAppConnectionsStats) {
      state.whatsAppConnectionsStats = whatsAppConnectionsStats;
    },
    setWhatsAppConnectionsPerAgencyStats(state, whatsAppConnectionsPerAgencyStats) {
      state.whatsAppConnectionsPerAgencyStats = whatsAppConnectionsPerAgencyStats;
    },
    setWhatsAppMessagesStats(state, whatsAppMessagesStats) {
      state.whatsAppMessagesStats = whatsAppMessagesStats;
    },
    setWhatsAppMessagesPerAgencyCustomer(state, whatsAppMessagesPerAgencyCustomer) {
      state.whatsAppMessagesPerAgencyCustomer = whatsAppMessagesPerAgencyCustomer;
    },
    setStatisticsFromStatistics(state, statisticsFromStatistics) {
      state.statisticsFromStatistics = statisticsFromStatistics;
    },
    setWhatsAppUsage(state, whatsAppUsage) {
      state.whatsAppUsage = whatsAppUsage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setProgress(state, progress) {
      state.progress = { ...state.progress, ...progress };
    },
    resetProgress(state) {
      state.progress = {
        currentStep: 0,
        totalSteps: 0,
        currentStatisticName: null,
      };
    },
  },
  
  actions: {
    async fetchMostRecentStatistic({ commit }) {
      commit("setLoading", true);
      try {
        const response = await apiClient.get("/getters/getMostRecentStatistic");
        commit("setSourceOfLeads", response.data.leadSource);
        commit("setSourceOfLeadsPast30Days", response.data.leadSourcePast30Days);
        commit("setSourceOfLeadsPast7Days", response.data.leadSourcePast7Days);
        commit("setemailConnections", response.data.emailConnections);
        commit("setTableStats", response.data.tableStats);
        commit("setCustomerStats", response.data.customerStats);
        commit("setAgencyStats", response.data.agencyStats);
        commit("setCustomerLoginStats", response.data.customerLoginStats);
        commit("setWhatsAppConnectionsStats", response.data.whatsAppConnections);
        commit("setWhatsAppConnectionsPerAgencyStats", response.data.whatsAppConnectionsPerAgency);
        commit("setWhatsAppMessagesStats", response.data.whatsAppMessages);
        commit("setWhatsAppMessagesPerAgencyCustomer", response.data.whatsAppMessagesPerAgencyCustomer);
        commit("setStatisticsFromStatistics", response.data.statisticsFromStatistics);
        commit("setWhatsAppUsage", response.data.whatsAppUsage);
        commit("setStatisticsAge", response.data.createdAt);
      } catch (error) {
        console.error("Failed to fetch most recent statistic:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchStatistics({ dispatch, commit }) {
      const statistics = [
        { name: "Lead Source", action: "fetchSourceOfLeads" },
        { name: "Email Connections", action: "fetchEmailConnections" },
        { name: "Table Statistics", action: "fetchTableStats" },
        { name: "Customer Statistics", action: "fetchCustomerStats" },
        { name: "Agency Statistics", action: "fetchAgencyStats" },
        { name: "Customer Login Statistics", action: "fetchCustomerLoginStats" },
        { name: "WhatsApp Connections", action: "fetchWhatsAppConnectionsStats" },
        { name: "WhatsApp Connections per Agency", action: "fetchWhatsAppConnectionsPerAgencyStats" },
        { name: "WhatsApp Messages", action: "fetchWhatsAppMessagesStats" },
        { name: "WhatsApp Messages per Agency Customer", action: "fetchWhatsAppMessagesPerAgencyCustomer" },
        { name: "WhatsApp Usage", action: "fetchWhatsAppUsage" },
        { name: "Statistics from Statistics", action: "fetchStatisticsFromStatistics" },
      ];

      commit("setLoading", true);
      commit("resetProgress");
      commit("setProgress", { totalSteps: statistics.length });

      try {
        for (let i = 0; i < statistics.length; i++) {
          const stat = statistics[i];
          commit("setProgress", {
            currentStep: i + 1,
            currentStatisticName: stat.name,
          });
          await dispatch(stat.action);
        }
      } catch (error) {
        console.error("Error calculating statistics:", error);
        throw error;
      } finally {
        commit("setLoading", false);
        commit("resetProgress");
      }
    },
    async fetchSourceOfLeads({ commit }) {
      try {
        const response = await apiClient.post("/statistics/calcSourceOfLeads");
        commit("setSourceOfLeads", response.data.overall);
        commit("setSourceOfLeadsPast30Days", response.data.past30Days);
        commit("setSourceOfLeadsPast7Days", response.data.past7Days);
        commit("setStatisticsAge", new Date());
      } catch (error) {
        console.error("Failed to fetch source of leads:", error);
        throw error;
      }
    },
    async fetchEmailConnections({ commit }) {
      try {
        const response = await apiClient.post("/statistics/calcEmailConnections");
        commit("setemailConnections", response.data);
      } catch (error) {
        console.error("Failed to fetch email connections:", error);
        throw error;
      }
    },
    async fetchTableStats({ commit }) {
      try {
        const response = await apiClient.post("/statistics/calcTableStatistics");
        commit("setTableStats", response.data);
      } catch (error) {
        console.error("Failed to fetch table statistics:", error);
        throw error;
      }
    },
    async fetchCustomerStats({ commit }) {
      try {
        const response = await apiClient.post("/statistics/calcCustomerStatistics");
        commit("setCustomerStats", response.data);
      } catch (error) {
        console.error("Failed to fetch customer statistics:", error);
        throw error;
      }
    },
    async fetchAgencyStats({ commit }) {
      try {
        const response = await apiClient.post("/statistics/calcAgencyStatistics");
        commit("setAgencyStats", response.data);
      } catch (error) {
        console.error("Failed to fetch agency statistics:", error);
        throw error;
      }
    },
    async fetchCustomerLoginStats({ commit }) {
      try {
        const response = await apiClient.post("/statistics/calcCustomerLoginsStatistics");
        commit("setCustomerLoginStats", response.data);
      } catch (error) {
        console.error("Failed to fetch customer login statistics:", error);
        throw error;
      }
    },
    async fetchWhatsAppConnectionsStats({ commit }) {
      try {
        const response = await apiClient.post("/statistics/calcWhatsAppConnectionsStatistics");
        commit("setWhatsAppConnectionsStats", response.data);
      } catch (error) {
        console.error("Failed to fetch WhatsApp connections statistics:", error);
        throw error;
      }
    },
    async fetchWhatsAppConnectionsPerAgencyStats({ commit }) {
      try {
        const response = await apiClient.post("/statistics/calcWhatsAppConnectionsPerAgencyStatistics");
        commit("setWhatsAppConnectionsPerAgencyStats", response.data);
      } catch (error) {
        console.error("Failed to fetch WhatsApp connections per agency statistics:", error);
        throw error;
      }
    },
    async fetchWhatsAppMessagesStats({ commit }) {
      try {
        const response = await apiClient.post("/statistics/calcWhatsAppMessagesStatistics");
        commit("setWhatsAppMessagesStats", response.data);
      } catch (error) {
        console.error("Failed to fetch WhatsApp messages statistics:", error);
        throw error;
      }
    },
    async fetchWhatsAppMessagesPerAgencyCustomer({ commit }) {
      try {
        const response = await apiClient.post("/statistics/calcWhatsAppMessagesPerAgencyCustomer");
        commit("setWhatsAppMessagesPerAgencyCustomer", response.data);
      } catch (error) {
        console.error("Failed to fetch WhatsApp messages per agency customer statistics:", error);
        throw error;
      }
    },
    async fetchWhatsAppUsage({ commit }) {
      try {
        const response = await apiClient.post("/statistics/calcFeatureUsage");
        commit("setWhatsAppUsage", response.data);
      } catch (error) {
        console.error("Failed to fetch WhatsApp usage statistics:", error);
        throw error;
      }
    },
    async fetchStatisticsFromStatistics({ commit }) {
      try {
        const response = await apiClient.post("/statistics/calcStatisticsFromStatistics");
        commit("setStatisticsFromStatistics", response.data);
      } catch (error) {
        console.error("Failed to fetch statistics from statistics:", error);
        throw error;
      }
    },
  },
};
